import { render, staticRenderFns } from "./ContractsList.vue?vue&type=template&id=a870e7d2&scoped=true&"
import script from "./ContractsList.vue?vue&type=script&lang=js&"
export * from "./ContractsList.vue?vue&type=script&lang=js&"
import style0 from "./ContractsList.vue?vue&type=style&index=0&id=a870e7d2&lang=scss&scoped=true&"
import style1 from "./ContractsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a870e7d2",
  null
  
)

export default component.exports